// Module
var code = "<div></div> ";
// Exports
export default code;